import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AccordionWrapper = styled(Box)<{ $isClosed:boolean }>(({ theme, $isClosed }) => ({
  backgroundColor: theme.customColors.drawerWidgetBg,
  borderRadius: theme.spacing(2),
  overflow: "hidden",
  transition: "background 0.1s ease",
  width: "100%",
  ...$isClosed && {
    "&:focus": {
      background:`rgba(${theme.customColors.backgroundSecondaryHover})`
    },
    "&:hover": {
      background:`rgba(${theme.customColors.backgroundSecondaryHover})`
    }
  }
}));

export const AccordionHeader = styled(Box)(({ theme }) => ({
  alignItems: "flex-start",
  cursor: "pointer",
  display: "flex",
  // gap: "0.75rem",
  padding: theme.spacing(2),
  userSelect: "none",

  [theme.breakpoints.down("sm")]: {
    columnGap: theme.spacing(1.5),
    padding: theme.spacing(1.5)
  }
}));

export const CoverImage = styled("img")(() => ({
  borderRadius: "0.5rem",
  flexShrink: 0,
  height: "3.8125rem",
  objectFit: "cover",
  width: "6.75rem"

  // "@media (max-width: 600px)": {
  //   height: 56,
  //   width: 72
  // }
}));

export const HeaderContent = styled(Box)(() => ({
  alignSelf: "center",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: 4
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.125rem",
  fontWeight: 700,
  lineHeight: 1.3,

  [theme.breakpoints.down("sm")]: {
    fontSize: "0.9375rem"
  }
}));

export const MetaTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.75rem",
  fontWeight: 400,
  lineHeight: "0.9875rem",
  alignItems: "center",
  display: "flex"
}));
export const NumberLOTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "1rem",
  fontWeight: 600,
  lineHeight: "1.1875rem"
}));

export const HeaderRight = styled(Box)(({ theme }) => ({
  alignItems: "flex-end",
  alignSelf: "center",
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  gap: theme.spacing(1),
  margin: "auto 0 1.5rem 0"
}));

export const BadgeChip = styled(Box)(({ theme }) => ({
  alignItems: "center",
  border: `1px solid ${theme.customColors.borderSecondaryComplete}`,
  borderRadius: theme.spacing(0.5),
  color: theme.customColors.borderSecondaryComplete,
  display: "flex",
  fontSize: "0.75rem",
  fontWeight: 600,
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1),
  whiteSpace: "nowrap"
}));

interface AccordionBodyProps {
  isStandaloneComponent?: boolean;
}

export const AccordionBody = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isStandaloneComponent"
})<AccordionBodyProps>(({ theme, isStandaloneComponent }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  marginTop: isStandaloneComponent ? "2rem" : 0,
  padding: isStandaloneComponent ? undefined : theme.spacing(0, 2, 2),
  ...(!isStandaloneComponent && {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 1.5, 1.5)
    }
  })
}));

export const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.75rem",
  fontWeight: 400,
  lineHeight: 1.6
}));
